import Model, { attr } from '@ember-data/model';
import classic from 'ember-classic-decorator';

@classic
export default class DocumentModel extends Model {
  @attr() documentName;
  @attr() documentExt;
  @attr('moment') createdAt;
}
